import { announcementsRoutes } from '@/backend/config/routes';
import { AnnouncementsForm } from '@/ui/features/announcements/components';
import { useCreateGlobalMenuRoutes } from '@/ui/hooks/useCreateGlobalMenuRoutes';
import { useAlertsRoutes } from '@juvare/alert-ui/ui/hooks';
import { GlobalAppRouteObject } from '@juvare/common-web-ui/GlobalApp';
import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import React from 'react';

export const useCreateUserAppRoutes = () => {
    const { createGlobalMenuRoutes } = useCreateGlobalMenuRoutes();
    const userState = useUserState();
    const alertsRoutes = useAlertsRoutes();

    const createUserAppRoutes = (): GlobalAppRouteObject[] => {
        const routes: GlobalAppRouteObject[] = [...createGlobalMenuRoutes(alertsRoutes)];

        // Only admins and org members with 'manage-org-announcements' org permission have access to Announcements page
        if (
            requireAnySystemPermission(userState, 'manage-announcements') ||
            requireAnyOrgPermission(userState, 'manage-org-announcements')
        ) {
            routes.push({
                path: announcementsRoutes.form,
                element: <AnnouncementsForm />,
            });
        }

        return routes;
    };

    return { createUserAppRoutes };
};
